module.exports = __webpack_public_path__ + "images/bug_yellow_size_4_da4a78c7c515c9f460df0d690f1cbff9.png";